import React, {useState} from "react";
import Tabs from "../atoms/Tabs";
import ColorTab from "./ColorTab";
import ColorPickerTab from "./ColorPickerTab";

const ColorSelector = ({
                         code,
                         codeKeyData,
                         stepObject,
                         colorTarget,
                         colorItemObject: initialColorItemObject
                       }) => {
  const [currentTab, setCurrentTab] = useState("COLOR");
  const [colorByCategory, setColorByCategory] = useState(null);
  const [colorItemObject, setColorItemObject] = useState(null);

  return (
    <div className={"option-expand"}>
      <Tabs
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        stepObject={stepObject}
        code={colorTarget}
        setColorByCategory={setColorByCategory}
        setColorItemObject={setColorItemObject}
        codeKeyData={codeKeyData}
      />

      {currentTab === "COLOR" && (
        <ColorTab
          code={code}
          colorByCategory={colorByCategory}
          codeKeyData={codeKeyData}
          colorItemObject={colorItemObject}
        />
      )}

      {currentTab === "CUSTOM_COLOR" && (
        <ColorPickerTab
          code={code}
          colorItemObject={initialColorItemObject}
        />
      )}
    </div>
  );
}

export default ColorSelector;
